// Reading a data hook's state. Lives apart from aimQueries so a test that mocks the hooks still
// gets the real predicate.

/**
 * Is an enabled hook's data still on its way?
 *
 * A hook that has not started, or has a request in flight, is pending; one that finished is not,
 * even when it finished with null (a SQL NULL result). A disabled hook never starts, so it is
 * never pending.
 *
 * `settled` says whether the latest request finished. A state without it (a hand-built one in a
 * test) falls back to reading a null result with no error as not started.
 *
 * @param {{data?: *, loading?: boolean, error?: *, enabled?: boolean, settled?: boolean}} query a hook's return value
 * @returns {boolean}
 */
export const isPending = ({ data, loading, error, enabled, settled }) => {
  if (enabled === false) return false;
  if (loading) return true;
  if (settled !== undefined) return !settled;
  return data === null && !error;
};
